import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CartContext } from '../../contexts/CartContext';
import { TmShipMethod } from '../../tscapi/model/cart';
import { TmShipMethodRequest } from '../../tscapi/model/request/account_cart-request';

export const ShippingMethod = () => {
    const { cartData, updateShipMethod } = useContext(CartContext);

    const { t } = useTranslation();

    let selectedShipMethod: TmShipMethod = new TmShipMethod();
    selectedShipMethod.Method = '23';

    if (cartData && cartData.ShipCode && cartData.AvailableShipMethods && cartData.AvailableShipMethods.length > 0) {
        selectedShipMethod = cartData.AvailableShipMethods.find((x) => x.Method == cartData.ShipCode);
    }

    const [shipMethod, setShipMethod] = useState(selectedShipMethod.Method);

    useEffect(() => {
        if (cartData?.ShipCode) {
            setShipMethod(cartData.ShipCode);
        }
    }, [cartData?.ShipCode]);

    const hideRadioButtons = cartData?.AvailableShipMethods?.length === 1;

    const onShipMethodChange = (e) => {
        const selectedMethod = e.target.value;

        setShipMethod(selectedMethod);

        if (cartData?.ShipCode !== selectedMethod) {
            const shipmethodReq = new TmShipMethodRequest();
            shipmethodReq.ShipCode = selectedMethod;
            updateShipMethod(shipmethodReq);
        }
    };

    return (
        <>
            <div className="shippingMethodWrap">
                <div className="shippingmethod__label">
                    <h2 className="shippingmethod__text">{t('Shipping Method')}</h2>
                </div>
                <div className="shippingmethod__description">
                    {cartData && cartData.AvailableShipMethods ? (
                        <>
                            {cartData.AvailableShipMethods.map((shipmethod, index) => (
                                <div key={shipmethod.Method} className="shipmethod__container">
                                    <input
                                        name="shipmethodRad"
                                        type="radio"
                                        id={index.toString()}
                                        key={'a' + shipmethod.Method}
                                        onChange={onShipMethodChange}
                                        checked={shipMethod == shipmethod.Method}
                                        value={shipmethod.Method}
                                        style={{ display: 'none' }}
                                    />
                                    <label
                                        className={`ship__label ${hideRadioButtons ? 'ship__label--single-option' : ''}`}
                                        htmlFor={index.toString()}
                                    >
                                        {shipmethod.CourierType === 'NdcPickup' ||
                                        shipmethod.CourierType === 'EmployeePickup' ? (
                                            <div className="pickup-method">
                                                <div className="card__radio-container">
                                                    {!hideRadioButtons && (
                                                        <span className="shipping__radio-button">
                                                            <svg
                                                                className="shipping__radio--selected"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                viewBox="0 0 541.6 541.6"
                                                            >
                                                                <path
                                                                    data-name="svg 1"
                                                                    d="M270.8 0a270.9 270.9 0 1 0 .2 541.8A270.9 270.9 0 0 0 270.8 0zm0 522.5c-138.7 0-251.7-113-251.7-251.7s113-251.7 251.7-251.7 251.7 113 251.7 251.7-113 251.7-251.7 251.7z"
                                                                />
                                                                <circle cx="270.8" cy="270.8" r="169.2" />
                                                            </svg>

                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                viewBox="0 0 541.6 541.6"
                                                                className="shipping__radio--unselected"
                                                            >
                                                                <path d="M270.8 0C121.3 0 0 121.3 0 270.8s121.3 270.8 270.8 270.8 270.8-121.3 270.8-270.8S420.3 0 270.8 0zm0 522.5c-138.7 0-251.7-113-251.7-251.7s113-251.7 251.7-251.7 251.7 113 251.7 251.7-113 251.7-251.7 251.7z" />
                                                            </svg>
                                                        </span>
                                                    )}

                                                    <div className="pickup-method__content">
                                                        <div className="pickup-method__title">{shipmethod.Label}</div>

                                                        <div className="pickup-method__address">
                                                            6885 Kennedy Road, Mississauga, ON L5T 272
                                                        </div>
                                                        {shipmethod.Description &&
                                                            !shipmethod.Description.startsWith('NA') && (
                                                                <div className="pickup-method__date">
                                                                    <span
                                                                        className="pickup-method__date-value"
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: shipmethod.Description,
                                                                        }}
                                                                    />
                                                                </div>
                                                            )}
                                                    </div>

                                                    <div className="pickup-method__price">FREE</div>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="ship-method">
                                                <div className="card__radio-container">
                                                    {!hideRadioButtons && (
                                                        <span className="shipping__radio-button">
                                                            <svg
                                                                className="shipping__radio--selected"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                viewBox="0 0 541.6 541.6"
                                                            >
                                                                <path
                                                                    data-name="svg 1"
                                                                    d="M270.8 0a270.9 270.9 0 1 0 .2 541.8A270.9 270.9 0 0 0 270.8 0zm0 522.5c-138.7 0-251.7-113-251.7-251.7s113-251.7 251.7-251.7 251.7 113 251.7 251.7-113 251.7-251.7 251.7z"
                                                                />
                                                                <circle cx="270.8" cy="270.8" r="169.2" />
                                                            </svg>

                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                viewBox="0 0 541.6 541.6"
                                                                className="shipping__radio--unselected"
                                                            >
                                                                <path d="M270.8 0C121.3 0 0 121.3 0 270.8s121.3 270.8 270.8 270.8 270.8-121.3 270.8-270.8S420.3 0 270.8 0zm0 522.5c-138.7 0-251.7-113-251.7-251.7s113-251.7 251.7-251.7 251.7 113 251.7 251.7-113 251.7-251.7 251.7z" />
                                                            </svg>
                                                        </span>
                                                    )}

                                                    <div className="ship-method__content">
                                                        <span>
                                                            <span
                                                                className={`ship-method__title ${hideRadioButtons ? 'ship-method__title--single-option' : ''}`}
                                                            >
                                                                {shipmethod.Label}
                                                            </span>
                                                            {shipmethod.Description &&
                                                                !shipmethod.Description.startsWith('NA') && (
                                                                    <>
                                                                        <span className="ship-method__date-symbol">
                                                                            {' '}
                                                                            -{' '}
                                                                        </span>
                                                                        <span
                                                                            className="ship-method__date-value"
                                                                            dangerouslySetInnerHTML={{
                                                                                __html: shipmethod.Description,
                                                                            }}
                                                                        />
                                                                    </>
                                                                )}
                                                        </span>
                                                    </div>

                                                    <span className="ship-method__price">
                                                        {shipmethod.ShippingCost === '$0.00'
                                                            ? 'FREE'
                                                            : shipmethod.ShippingCost}
                                                    </span>
                                                </div>
                                            </div>
                                        )}
                                    </label>
                                </div>
                            ))}
                        </>
                    ) : null}
                </div>
            </div>
        </>
    );
};
